import script from "./ProductSaleVariantTableOtherSkeleton.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductSaleVariantTableOtherSkeleton.vue?vue&type=script&setup=true&lang=js"

import "./ProductSaleVariantTableOtherSkeleton.vue?vue&type=style&index=0&id=f7f45d9e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f7f45d9e"]])

export default __exports__